import { memo } from "react";

import { ShopifyProvider } from "@shopify/hydrogen-react";
import { ErrorBoundary } from "react-error-boundary";
import { SWRConfig } from "swr";

import {
  STOREFRONT_ACCESS_TOKEN,
  STOREFRONT_API_VERSION,
  SWR_SETTINGS,
} from "@tablescape/constants";

import { CountrySelectorModalRoot } from "./CountrySelectorModalRoot";

const CountrySelectorModalProviderBase = () => {
  return (
    <ErrorBoundary fallback={null}>
      <ShopifyProvider
        countryIsoCode={window.Shopify.country}
        languageIsoCode={window.Shopify.locale}
        storeDomain={window.location.origin}
        storefrontApiVersion={STOREFRONT_API_VERSION}
        storefrontToken={STOREFRONT_ACCESS_TOKEN}
      >
        <SWRConfig value={SWR_SETTINGS}>
          <CountrySelectorModalRoot />
        </SWRConfig>
      </ShopifyProvider>
    </ErrorBoundary>
  );
};

export const CountrySelectorModalProvider = memo(
  CountrySelectorModalProviderBase
);
